import SearchBar, { SearchBarProps } from "../../form/SearchBar/SearchBar";
import { User } from "../../../lib/types/UserTypes";
import React, { useCallback } from "react";
import AsyncState, { useAsyncState } from "react-async-stateful";
import { fetchFleetUsers } from "../../../Api";
import { useSelector } from "../../../lib/hook/ReduxHooks";
import {
	selectCurrentScope,
	selectCurrentScopeFleetId,
} from "../../../store/User/User.selector";
import { FilterElement } from "../../../lib/types/FilterSortTypes";

export interface UserSearchProps
	extends Omit<
		SearchBarProps<User>,
		"autocomplete" | "onAutocomplete" | "seeAll"
	> {
	searchKeys?: boolean;
	isAdminSearch?: boolean;
}

const UserSearch = (props: UserSearchProps) => {
	const [userSearch, setUserSearch, updateUserSearch] = useAsyncState<User[]>();

	const { onChange, searchKeys, isAdminSearch, ...otherProps } = props;

	const { scope } = useSelector((state) => ({
		scope: selectCurrentScope(state),
	}));

	const handleAutocomplete = useCallback(
		(value: string) => {
			let adminProps = {};
			if (isAdminSearch) {
				adminProps = {
					includeArchived: true,
					includeManagers: true,
					archiveRetentionWindow: 360 * 5, //5 years
				};
			}

			updateUserSearch(async () => {
				const res = await fetchFleetUsers.submit({
					params: {
						fleetId: scope.fleetId,
					},
					query: {
						...adminProps,
						group: scope.group,
						includeInvites: true,
						limit: 6,
						sort: [
							{
								key: "email",
								direction: "DESC",
							},
						],
						filter: {
							type: "OR",
							elements: [
								searchKeys && {
									type: "FILTER",
									key: "key",
									operation: "CONTAINS",
									value: value,
								},
								{
									type: "FILTER",
									key: "name",
									operation: "CONTAINS",
									value: value,
								},
								{
									type: "FILTER",
									key: "email",
									operation: "CONTAINS",
									value: value,
								},
							].filter(Boolean) as FilterElement[],
						},
					},
				});
				return res.data;
			});
		},
		[isAdminSearch, updateUserSearch, scope.fleetId, scope.group, searchKeys],
	);

	const handleChange = useCallback(
		(value: string) => {
			setUserSearch(AsyncState.pending);
			if (onChange) {
				onChange(value);
			}
		},
		[onChange, setUserSearch],
	);

	return (
		<SearchBar
			autocomplete={userSearch}
			onAutocomplete={handleAutocomplete}
			onChange={handleChange}
			{...otherProps}
			seeAll={{
				href: "/drivers#all",
			}}
		/>
	);
};

export default UserSearch;
